import { useMemo, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { usePrevious } from '../../hooks/usePrevious';
import { analyticsActions } from '../../redux/analytics/actions/AnalyticsActions.creators';
export const ReturnItemsChangeHandler = () => {
    const { watch } = useFormContext();
    const dispatch = useDispatch();
    const saleLines = watch('saleLines');
    const returnOptionId = watch('returnOptionId');
    const selectedItemsCount = useMemo(() => {
        return saleLines.filter(saleLine => !!saleLine.isSelected).length;
    }, [saleLines]);
    const previousCount = usePrevious(selectedItemsCount);
    useEffect(() => {
        if (previousCount === null)
            return;
        const currentCount = saleLines.filter(saleLine => !!saleLine.isSelected).length;
        if (previousCount < currentCount) {
            dispatch(analyticsActions.returnProductSelected());
        }
        else if (previousCount > currentCount) {
            dispatch(analyticsActions.returnProductUnselected());
        }
    }, [saleLines]);
    useEffect(() => {
        if (!returnOptionId)
            return;
        dispatch(analyticsActions.returnMethodSelected(returnOptionId));
    }, [returnOptionId]);
    return null;
};
